export default __webpack_public_path__ + "static/media/arrowAdressLeft.3d172ed2.svg";